import { createStore } from 'vuex'
//import moment from 'moment';
import axios from 'axios';

/** Convertit "HH:MM:SS" en secondes (0 si format invalide). */
function hmsToSeconds(hms) {
  const parts = String(hms || '').split(':').map((p) => parseInt(p, 10));
  if (parts.length !== 3 || parts.some((n) => Number.isNaN(n))) return 0;
  return parts[0] * 3600 + parts[1] * 60 + parts[2];
}

/** Tri durée croissante (kayak, trail) ; "00:00:00" en fin de liste. */
function compareHmsDurations(ta, tb) {
  const aZero = ta === '00:00:00';
  const bZero = tb === '00:00:00';
  if (aZero !== bZero) return aZero ? 1 : -1;
  if (aZero) return 0;
  return hmsToSeconds(ta) - hmsToSeconds(tb);
}

/** Tri durée croissante (pénalité) ; "00:00:00" classé normalement (0 s). */
function compareHmsDurationsPlain(ta, tb) {
  return hmsToSeconds(ta) - hmsToSeconds(tb);
}

export default createStore({

  state: {
    filters: {
      search: "",
    },
    current_epreuve: "raid",
    current_sexe: "f",
    runners: [],
  },
  mutations: {
    setCurrentEpreuve(state, epreuve) {
      state.current_epreuve = epreuve;
    },
    setSexe(state, sexe) {
      state.current_sexe = sexe;
    },
    setRunners(state, runners) {
      state.runners = runners;
    },
    setSearchFilters(state, search) {
      state.filters.search = search;
    },
  },
  getters: {
    getEpreuveResults(state) {
      const current_epreuve = state.current_epreuve;
      // Copie pour ne pas muter state.runners ; tri sur durée HH:MM:SS
      let runners = state.runners.slice();

      if (state.current_sexe == 'f') {
        runners = runners.filter((runner) => runner.sexe == 'F');
      } else {
        runners = runners.filter((runner) => runner.sexe == 'X');
      }

      if (current_epreuve === 'kayak') {
        runners.sort((a, b) =>
          compareHmsDurations(
            a.kayak?.temps ?? '00:00:00',
            b.kayak?.temps ?? '00:00:00'
          )
        );
      } else if (current_epreuve === 'trail') {
        runners.sort((a, b) =>
          compareHmsDurations(
            a.trail?.temps ?? '00:00:00',
            b.trail?.temps ?? '00:00:00'
          )
        );
      } else if (current_epreuve === 'penalite') {
        runners.sort((a, b) =>
          compareHmsDurationsPlain(
            a.penalite?.temps ?? '00:00:00',
            b.penalite?.temps ?? '00:00:00'
          )
        );
      }
      return runners;
    },
  },
  actions: {
    async fetchRunners({ commit }) {
      try {
        const response = await axios.get('https://sportips.fr/api/v1/maxime-laidies-raid/get.php');
        commit('setRunners', response.data);
      } catch (error) {
        console.error(error);
      }
    },
  },

})
